import React from 'react';
import BettingWrapper from "./BettingWraper";
import useMobileViewport from "../../roulette/mobile/useMobileViewport";

const Dashboard = () => {
    useMobileViewport()
    return <div id="lo12v2-mobile">
        <div className="dash-wrapper lotto12v2">
            <BettingWrapper />
        </div>
    </div>
};

export default Dashboard;